import {ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit} from '@angular/core';
import {AnhangMetadaten, Nachricht, NachrichtPayload} from "../../core/model/nachricht/nachricht";
import {NachrichtFormComponent} from "../nachricht-form/nachricht-form.component";
import {ActivatedRoute} from "@angular/router";
import {HistorienElement} from "../../core/model/historien-element";
import {Subject, takeUntil} from "rxjs";
import {vNiveauEnum} from "../../core/model/nachricht/vniveau.enum";
import {AnliegenHelperService} from "../anliegen-helper.service";
import {ScrollIntoView} from "../../shared/directives/scroll-into-view.directive";
import {NavigationService} from "../../shared/utils/navigation.service";
import {APP_ROUTES} from "../../route-constants";
import {NachrichtStateEnum} from "../nachricht-state.enum";
import {NachrichtSuccessType} from "../nachricht-success-type.enum";
import {UserAccountService} from "../../core/services/user-account.service";

@Component({
    selector: 'kokos-nachricht-antworten',
    imports: [
        NachrichtFormComponent,
        ScrollIntoView
    ],
    templateUrl: './nachricht-antworten.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class NachrichtAntwortenComponent implements OnInit, OnDestroy {


    nachrichtPayload: NachrichtPayload = null;

    nachrichtHistorie: HistorienElement[];

    anliegenName: string;
    subanliegenName: string;
    anhangErlaubt: boolean;


    gesendet = false;

    nachrichtState: NachrichtStateEnum = NachrichtStateEnum.PREPARE;

    nachrichtSuccessType: NachrichtSuccessType;


    private readonly userAccountService = inject(UserAccountService);
    private readonly anliegenHelperService = inject(AnliegenHelperService);
    private readonly nav = inject(NavigationService);
    private readonly route = inject(ActivatedRoute);
    protected readonly NachrichtStateEnum = NachrichtStateEnum;
    private readonly destroy$ = new Subject<void>();

    ngOnInit(): void {

        const benutzerRechte = this.route.snapshot.data['benutzerRechte'];

        if (!benutzerRechte) {
            throw new Error('Missing benutzerRechte');
        }

        if (this.userAccountService.isRestricted()) {
            globalThis.setTimeout(() => {
                this.nav.goTo('/' + APP_ROUTES.KEIN_ONLINE_ZUGRIFF);
            }, 0);
        }

        const vorgaengerNachricht = this.route.snapshot.data['vorgaenger'];
        if (vorgaengerNachricht) {
            this.nachrichtPayload = this.initializeNachricht(vorgaengerNachricht);
            this.retrieveAnliegen(vorgaengerNachricht);
        } else {
            throw new Error("Vorgängernachricht nicht gefunden");
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initializeNachricht(vorgaengerNachricht: Nachricht): NachrichtPayload {

        const nachrichtPayload = {} as NachrichtPayload;

        nachrichtPayload.vorgaengerId = vorgaengerNachricht.nachrichtId;
        nachrichtPayload.vNiveau = vorgaengerNachricht.vNiveau ?? vNiveauEnum.DEFAULT; // nochmal prüfen, ob das richtig ist und wie es zuvor war
        nachrichtPayload.bezug = vorgaengerNachricht.bezug;
        nachrichtPayload.betreff = vorgaengerNachricht.betreff;
        nachrichtPayload.empfaengerId = vorgaengerNachricht.dienststellennummer;
        nachrichtPayload.empfaengerName = vorgaengerNachricht.dienststellenname;

        const vorgaengerAsHistoryElement: HistorienElement = {
            text: vorgaengerNachricht.text,
            senderName: vorgaengerNachricht.senderName,
            senderId: vorgaengerNachricht.senderId,
            empfaengerName: vorgaengerNachricht.empfaengerName,
            empfaengerId: vorgaengerNachricht.empfaengerId,
            autorName: vorgaengerNachricht.autorName,
            autorId: vorgaengerNachricht.autorId,
            datum: vorgaengerNachricht.datum,
            anhaengeNamen: vorgaengerNachricht.anhaengeMetadaten?.map((anhangMetadaten: AnhangMetadaten) => anhangMetadaten.dateiname),
        };

        this.nachrichtHistorie = vorgaengerNachricht.historie;
        this.nachrichtHistorie?.unshift(vorgaengerAsHistoryElement);

        return nachrichtPayload;
    }


    private retrieveAnliegen(nachricht: Nachricht): void {
        this.anliegenHelperService.getAnliegenInfo(nachricht)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (anliegenInfo) => {
                    this.anliegenName = anliegenInfo.anliegenName
                    this.subanliegenName = anliegenInfo.subanliegenName;
                    this.anhangErlaubt = anliegenInfo.anhangErlaubt;
                    this.nachrichtState = NachrichtStateEnum.FORM;
                },
                error: (err) => {
                    throw err
                },
            });
    }

}
